import { useEffect } from 'react'
import { stopDatadog } from './datadogInit'

export function useStopDatadogOnTabClose() {
  useEffect(() => {
    const handleBeforeUnload = () => {
      stopDatadog()
    }
    window.addEventListener('beforeunload', handleBeforeUnload)
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload)
    }
  }, [])
}